export default class SalesAIAnswerViewModel {
    public isActive: boolean = false;
    public channel: string = '';
    public question: string = '';
    public category: string = '';
    public answer: string = '';
}